angular.module('iqxCore')
.service('IQXPDFSvc', function () {
	var svc=this
  svc.ispdf=true

  /*
    * domID: the HTML ID of what you want converted into a PDF
    * filename: what you would like the PDF to be called
    * type: download / print / open (currently only download works!)
    * docDefinition: if you would like to setup custom parameters you can do so here (DOC here: http://pdfmake.org/index.html/gettingstarted)
   */
  svc.PDF = function (domID, filename, type, docDefinition) {
    domID = domID || 'pdfnull'
    html2canvas(document.getElementById(domID), {
      onrendered: function (canvas) {
        let data = canvas.toDataURL()
        docDefinition = docDefinition || {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          // fit: [1000, 800],
          content: [{
            image: data,
            width: 1000
          }]
        }
        switch(type){
          case 'download':
            return pdfMake.createPdf(docDefinition)
            .download( filename + ".pdf" )
          break

          case 'print':
            return pdfMake.createPdf(docDefinition)
            .print()
          break

          case 'open':
            return pdfMake.createPdf(docDefinition)
            .open()
          break
        }
      }
    })
  }
})